import React from 'react';
import PropTypes from 'prop-types';

const ErrorRow = ({ msg }) => (
  <tr className="DealerOpeningTimes__error-row">
    <td className="DealerOpeningTimes__error-column" colSpan={6}>
      {msg}
    </td>
  </tr>
);

ErrorRow.propTypes = {
  msg: PropTypes.node.isRequired,
};

export default ErrorRow;



// WEBPACK FOOTER //
// ../ui-components/components/DealerOpeningTimes/ErrorRow.jsx